// Kafel dowozu na podstronie Kontakt. Sam niczego nie liczy - przekazuje
// wpisany kod pocztowy do okna "Sprawdz dostawe pod swoj adres", ktore stoi
// w layoucie i trzyma jedyna liste krajow i zakresow (bloki sekcji
// delivery-check). Dzieki temu werdykt jest ten sam, co przy dodaniu do
// koszyka, a tu nie powstaje druga kopia regul.
(() => {
  const start = (zakres) => {
    const korzen = zakres || document;
    const kafle = korzen.querySelectorAll('[data-contact-zone]');

    korzen.querySelectorAll('[data-contact-booking]').forEach((przycisk) => {
      if (przycisk.dataset.bookingGotowy === '1') return;
      przycisk.dataset.bookingGotowy = '1';
      przycisk.addEventListener('click', (zdarzenie) => {
        const magazyn = przycisk.dataset.bookingWarehouse;
        if (magazyn && window.dizzDostawa?.umow && window.dizzDostawa.umow(magazyn)) {
          zdarzenie.preventDefault();
          return;
        }
        // Bez kalendarza odnosnik prowadzi do formularza na tej stronie - z
        // gotowym zdaniem o wizycie w tym magazynie, zeby klient nie zaczynal
        // od pustej wiadomosci (audyt na slepo 26.10.2026).
        const pole = document.querySelector('#zapytanie textarea, form textarea[name="contact[body]"]');
        if (pole && !pole.value.trim() && przycisk.dataset.bookingMessage) {
          pole.value = przycisk.dataset.bookingMessage;
          window.setTimeout(() => {
            pole.focus({ preventScroll: true });
            pole.setSelectionRange(pole.value.length, pole.value.length);
          }, 400);
        }
      });
    });

    kafle.forEach((kafel) => {
      if (kafel.dataset.gotowy === '1') return;
      kafel.dataset.gotowy = '1';

      const pole = kafel.querySelector('[data-contact-zone-zip]');
      const przycisk = kafel.querySelector('[data-contact-zone-submit]');

      const przekaz = () => {
        const kod = pole ? pole.value.trim() : '';
        const okno = document.querySelector('delivery-check');

        // Okno wylaczone w panelu (pusty naglowek) - kafel zostaje wtedy
        // zwyklym polem bez odpowiedzi, wiec lepiej nie udawac, ze dziala.
        if (!okno || !window.dizzDostawa) return;

        window.dizzDostawa.otworz(null);

        const wejscie = okno.querySelector('[data-delivery-zip]');
        if (wejscie && kod) {
          wejscie.value = kod;
          // Okno czyta pole dopiero przy sprawdzaniu, ale czysci blad na
          // wpisywaniu - to zdarzenie utrzymuje oba zachowania spojne.
          wejscie.dispatchEvent(new Event('input', { bubbles: true }));
        }
      };

      if (przycisk) przycisk.addEventListener('click', przekaz);

      if (pole) {
        pole.addEventListener('keydown', (zdarzenie) => {
          if (zdarzenie.key !== 'Enter') return;
          zdarzenie.preventDefault();
          przekaz();
        });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => start());
  } else {
    start();
  }

  // Edytor motywu podmienia HTML sekcji bez odswiezania strony.
  document.addEventListener('shopify:section:load', (zdarzenie) => start(zdarzenie.target));
})();
